import { render } from "./upload.vue?vue&type=template&id=5f654c27&ts=true"
import script from "./upload.ts?vue&type=script&lang=ts&external"
export * from "./upload.ts?vue&type=script&lang=ts&external"

import "./upload.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__